import { DataRecoveryLegalCaseActions } from './partials/legal-case'

export const DataRecoveryActions = {
  ...DataRecoveryLegalCaseActions,
}
